/* eslint react-hooks/exhaustive-deps: "warn" */

import type { KeyboardEvent } from 'react';

import cn from 'classnames';

import styles from './RegisChat.module.scss';

import type { RegisChatProps } from './RegisChat.types';

export const RegisChat = ({
  title = 'Regis',
  status = 'Connected to registry data',
  messages,
  placeholder = "Ask Regis about any company's financials...",
  submitLabel = 'Ask →',
  value,
  onValueChange,
  onSubmit,
  onBack,
  showBack = false,
  inputType = 'text',
  loading = false,
  submitDisabled = false,
  error,
  note,
  className,
}: RegisChatProps) => {
  const interactive = typeof onValueChange === 'function';

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onSubmit?.();
    }
  };

  return (
    <div className={cn(styles.window, className)}>
      <div className={styles.bar}>
        <span className={styles.barTitle}>
          <span className={styles.spark}>✦</span> {title}
        </span>

        <span className={styles.barStatus}>{status}</span>
      </div>

      <div className={styles.chat}>
        {messages.map((message, i) => (
          <div key={i} className={cn(styles.msg, message.from === 'user' ? styles.msgUser : styles.msgAssistant)}>
            {message.content}
          </div>
        ))}
      </div>

      <div className={styles.input}>
        {showBack && (
          <button type="button" className={styles.back} onClick={onBack} aria-label="Back">
            ‹
          </button>
        )}

        <span className={styles.spark}>✦</span>

        <input
          type={inputType}
          value={interactive ? (value ?? '') : undefined}
          onChange={interactive ? (event) => onValueChange?.(event.target.value) : undefined}
          onKeyDown={interactive ? handleKeyDown : undefined}
          placeholder={placeholder}
          aria-label={placeholder}
          readOnly={!interactive}
        />

        <button type="button" className={styles.submit} onClick={onSubmit} disabled={submitDisabled || loading}>
          {submitLabel}
        </button>
      </div>

      {error && <p className={styles.error}>{error}</p>}

      {note && <div className={styles.note}>{note}</div>}
    </div>
  );
};
